import { Folder } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'

import AddToProjectsModal from '@/components/shared/AddToProjectsModal/AddToProjectsModal'

import { useTrackActions } from '../TrackActions.hooks'
import { AddToProjectProps } from './AddToProject.types'

const AddToProject = ({
	track,
	source,
	...props
}: AddToProjectProps): JSX.Element => {
	const { t } = useTranslation(['trackrow'])
	const { addToProjectModalId, handleAddToProjectOpen } = useTrackActions({
		track,
		source,
	})

	return (
		<>
			<Folder
				title={t('track-actions.add-to-project')}
				aria-label={t('track-actions.add-to-project')}
				onClick={handleAddToProjectOpen}
				command="show-modal"
				commandfor={addToProjectModalId}
				{...props}
			/>
			<AddToProjectsModal
				id={addToProjectModalId}
				tracks={[track]}
				source={source}
			/>
		</>
	)
}

export default AddToProject
